"use client";

import { useEffect } from "react";

// After each deploy/rebuild, an already-open tab still runs the previous
// build's runtime and fails to lazy-load chunks that no longer exist
// (ChunkLoadError). Recover by reloading once — guarded per-URL so a
// genuine loading bug can't loop forever.
export function ChunkReload() {
  useEffect(() => {
    function recover(reason: unknown) {
      const msg = reason instanceof Error ? `${reason.name} ${reason.message}` : String(reason ?? "");
      if (!/ChunkLoadError|Loading chunk|Failed to load chunk|Failed to fetch dynamically imported module/i.test(msg)) return;
      const key = "chunk-reload:" + location.pathname;
      if (sessionStorage.getItem(key)) return; // already retried this URL once
      sessionStorage.setItem(key, "1");
      location.reload();
    }
    const onErr = (e: ErrorEvent) => recover(e.error ?? e.message);
    const onRej = (e: PromiseRejectionEvent) => recover(e.reason);
    window.addEventListener("error", onErr);
    window.addEventListener("unhandledrejection", onRej);
    return () => {
      window.removeEventListener("error", onErr);
      window.removeEventListener("unhandledrejection", onRej);
    };
  }, []);
  return null;
}
